<template>
  <d-list-group-item class="text-center">
    <table
      class="table mb-0 responsive-table table-schedule"
      style="border: 1px #dee2e6 solid;table-layout: fixed;">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0 col-id">#</th>
          <th scope="col" class="border-0">Data płatności</th>
          <th scope="col" class="border-0">Rata</th>
          <th scope="col" class="border-0">Wpłacono</th>
          <th scope="col" class="border-0">Kapitał</th>
          <th scope="col" class="border-0">Odsetki</th>
          <th scope="col" class="border-0">Odsetki karne</th>
          <th scope="col" class="border-0">Data wpłaty</th>
          <th scope="col" class="border-0">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(installment, index) in scheduleInstallments"
          :class="[
            { red : rowThemeDanger(installment) },
            { green : rowThemeSuccess(installment) },
            { disabled : !rowThemeSuccess(installment) && isScheduleTerminated },
          ]" >
          <td>
            <dt>#</dt>
            <dd>{{ (parseInt(index) + 1) }}</dd>
          </td>
          <td>
            <dt>Data płatności</dt>
            <dd v-if="installment.paid_date || installment.is_paid === 1">
              {{ installment.payment_date ? installment.payment_date.substring(0, 10) : '-' }}
            </dd>
            <dd v-else="installment.paid_date">
              <ss-date
                type="text"
                name="payment_date"
                v-model="installment.payment_date"
                @click="lar_errors.clear('payment_date')"
                :limitfrom="getLimitFrom(index)"
                :limitto="getLimitTo(index)"
                :class="{'is-invalid' : lar_errors.has('payment_date')}"
                placeholder=""/>
            </dd>
          </td>
          <td>
            <dt>Rata</dt>
            <dd v-if="installment.is_paid === 0 && !isScheduleTerminated">
              <ss-price-input
                v-if="index < scheduleInstallments.length -1"
                type="text"
                :disabled="installment.amount_paid > 0 || installment.interest_penalty > 0"
                name="installment_fee"
                v-model="installment.installment_fee"
                @input="singleInstallmentChanged" />
              <ss-price-input
                v-else
                :readonly="true"
                type="text"
                name="installment_fee"
                :value="lastInstallment" />
            </dd>
            <dd v-else>
              {{ toNumber(installment.last_installment_fee_with_interest ? installment.last_installment_fee_with_interest : installment.installment_fee) }} zł
            </dd>
          </td>
          <td>
            <dt>Wpłacono</dt>
            <dd>{{ toNumber(installment.amount_paid) }} zł</dd>
          <td>
            <dt>Kapitał</dt>
            <dd>{{ toNumber(installment.capital) }} zł</dd>
          </td>
          <td :class="{ 'is-loading': interestsLoading }">
            <dt>Odsetki</dt>
            <dd>{{ toNumber(installment.interest) }} zł</dd>
          </td>
          <td>
            <dt>Odsetki karne</dt>
            <dd v-if="isScheduleTerminated && (terminationDate < installment.payment_date)">
              0,00 zł
            </dd>
            <dd
              v-else
              :class="{ 'text-danger' : installment.interest_penalty > 0 }">
              {{ toNumber(installment.interest_penalty) }} zł
            </dd>
          </td>
          <td>
            <dt>Data wpłaty</dt>
            <dd>
              {{ installment.amount_paid === 0 ? '-' : (installment.paid_date ? installment.paid_date.substring(0, 10) : '-') }}
            </dd>
          </td>
          <td>
            <dt>Status</dt>
            <dd v-if="!!installment.is_paid">
              Opłacono
            </dd>
            <dd
              v-if="!(!!installment.is_paid) && !isScheduleTerminated"
              class="date-cell-wrapper"
              style="min-height: 35px;">
              <div class="popover-wrapper">
                <d-button
                  :class="{'btn-disabled': isChangedInstallments}"
                  @click.prevent="">
                  Opłacono
                </d-button>
                <div class="popover bs-popover-top bs-popover-center">
                  <div class="arrow"></div>
                  <div class="popover-body">
                    Zapisz zmiany w harmonogramie przed zmianą statusu płatności.
                  </div>
                </div>
              </div>
              <ss-date
                v-if="!isChangedInstallments"
                :id="'first_installment_date' + installment.id"
                @picked="saveInstallment(installment)"
                type="text"
                name="first_installment_date"
                v-model="installment.paid_date"
                placeholder=""/>
            </dd>
            <dd v-if="installment.is_paid === 0 && isScheduleTerminated">-</dd>
          </td>
        </tr>
        <tr
          v-if="!scheduleInstallments || !scheduleInstallments.length"
          colspan="9">
          Brak elementów do wyświetlenia
        </tr>
      </tbody>
    </table>
  </d-list-group-item>
</template>


<script>
import LarErrors from '@/helpers/Errors';
import SsDate from '@/components/common/SsDate';
import SsPriceInput from '@/components/common/SsPriceInput';

export default {
  name: 'ContractInstallmentsScheduleTab',
  components: {
    LarErrors,
    SsDate,
    SsPriceInput
  },
  props: {
    firstInstallmentDate: {
      type: String,
      default: null
    },
    isChangedInstallments: {
      type: Boolean,
      default: false
    },
    interestsLoading: {
      type: Boolean,
      default: false
    },
    isScheduleTerminated: {
      type: Boolean,
      default: false
    },
    lastInstallment: {
      type: Number,
      default: 0
    },
    scheduleInstallments: {
      type: Array,
      default: []
    },
    terminationDate: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      lar_errors:  LarErrors,
    }
  },
  methods: {
    singleInstallmentChanged () {
      this.$bus.$emit('contract-calculate-capitals');
    },
    saveInstallment (installment) {
      this.$nextTick(() => {
        axios.post('api/schedules/mark-installments-as-paid', installment).then(response => {
          if (response.data.status === 0) {
            Vue.swal({
              type: 'error',
              title: response.data.message,
              showConfirmButton: true,
            }).then(() => {
              this.$bus.$emit('reload-contract');
            });
          } else {
            Vue.swal({
              type: 'success',
              title: 'Rata została opłacona.',
              showConfirmButton: true,
            }).then(() => {
              this.$eventHub.$emit('refresh-payments-history');
              this.$bus.$emit('reload-contract');
            });
          }

          this.$eventHub.$emit('refresh-payments-history');
        }).catch((errors) => {
          Vue.swal({
            type: 'error',
            text: errors.response.data.error? errors.response.data.error : 'Wystąpił błąd podczas dodawania opłaty.'
          });
        })
      })
    },
    toNumber (number) {
      return Vue.toNumber(number);
    },
    getLimitFrom (index) {
      return index < 2 ? this.firstInstallmentDate : this.scheduleInstallments[(index - 1)].payment_date;
    },
    getLimitTo (index) {
      return index < (this.scheduleInstallments.length - 1) ? this.scheduleInstallments[(index + 1)].payment_date: '';
    },
    rowThemeDanger (inst) {
      inst = inst.last_installment_fee_with_interest ? this.lastInstallment : inst;
      return inst.capital < 0 || (inst.capital === 0 && inst.installment_fee === 0);
    },
    rowThemeSuccess (inst) {
      return inst.is_paid === 1;
    },
  },
}
</script>
